import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

export interface OrderModalType {
  openModal: boolean;
  title: string;
  description: string;
  primaryButtonName: string;
  secondaryButtonName: string;
  closeModalFn: () => void;
  onPrimaryButtonClick: () => void;
  hideSecondaryButton?: boolean;
  showCloseIcon?: boolean;
}

export interface ModalType {
  open: boolean;
  closeModal: () => void;
  primaryButtonClick: () => void;
}

const OrderModal = ({
  openModal,
  title,
  description,
  primaryButtonName,
  secondaryButtonName,
  closeModalFn,
  onPrimaryButtonClick,
  hideSecondaryButton,
  showCloseIcon,
}: OrderModalType) => (
  <Dialog
    data-testid="order-modal"
    fullWidth
    open={openModal}
    onClose={closeModalFn}
    aria-labelledby="alert-Modal-title"
    aria-describedby="alert-Modal-description"
  >
    <DialogTitle data-testid="order-modal-title">{title}</DialogTitle>
    {!showCloseIcon && (
      <IconButton
        aria-label="close"
        onClick={closeModalFn}
        size="large"
        sx={{
          position: "absolute",
          right: 15,
          top: 15,
        }}
      >
        <CloseIcon />
      </IconButton>
    )}
    <DialogContent>
      <DialogContentText data-testid="order-modal-description">
        {description}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {!hideSecondaryButton && (
        <Button
          onClick={closeModalFn}
          variant="text"
          data-testid="modal-secondary-button"
        >
          {secondaryButtonName}
        </Button>
      )}
      <Button
        onClick={onPrimaryButtonClick}
        variant="primary"
        data-testid="modal-primary-button"
      >
        {primaryButtonName}
      </Button>
    </DialogActions>
  </Dialog>
);

export default OrderModal;
